import Enumerable from "linq";
import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { ObjectAlert } from "../alerts";
import { IObjectValidator } from "../IObjectValidator";
import { CalculateObjectEditor } from "../objectEditors";
import { 
  ExpressionKinds, 
  ExpressionOperatorKinds,
  ExpressionLogicalOperatorKinds,
} from "../../../../documaker/domain/format/objects";

export class CalculateObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: ObjectAlert[] = [];
    if (object instanceof CalculateObjectEditor) {
        // 計算式の警告確認
      if (object.kind().getValue() === ExpressionKinds.Calculation) {
        const behavior = object.calculationExpressionBehavior().getValue();
        if (behavior.contents.length < 1) {
          alerts.push(new ObjectAlert(object, "計算対象項目を設定してください。"));
        }
        let count = 0;
        let rangeError = false;
        Enumerable.from(behavior.contents).forEach(s => {
          count += s.brackets.openCount - s.brackets.closeCount;
          if (count < 0) {
            rangeError = true;
          }
        });
        if (count !== 0) {
          alerts.push(new ObjectAlert(object, "計算式の括弧の数が一致しません。計算対象項目の設定を見直してください。"));
        }
        if (rangeError) {
          alerts.push(new ObjectAlert(object, "計算式の括弧で囲む範囲が一致しません。計算対象項目の設定を見直してください。"));
        }
      }

      // 条件式の警告確認
      if (object.kind().getValue() === ExpressionKinds.Conditional) {
        const behavior = object.conditionalExpressionBehavior().getValue();
        if (behavior.contents.length < 1) {
          alerts.push(new ObjectAlert(object, "条件式を設定してください。"));
        } else if (behavior.contents[behavior.contents.length - 1].logicalOperator !== ExpressionLogicalOperatorKinds.None) {
          alerts.push(new ObjectAlert(object, "複合条件が設定された次の条件式がありません。複合条件の後に条件式を追加してください。"));
        }

        let count = 0;
        let countError = false;
        let rangeError = false;
        Enumerable.from(behavior.contents).forEach(s => {
          if (s.operator !== ExpressionOperatorKinds.Matched
            && s.operator !== ExpressionOperatorKinds.Unmatched
            && isNaN(parseFloat(s.value))) {
              alerts.push(new ObjectAlert(object, "条件式の基準値は、一致・不一致の条件以外の時は数値を入力してください。"));
          }
          count += s.brackets.openCount - s.brackets.closeCount;
          if ((s.logicalOperator === ExpressionLogicalOperatorKinds.None) && (count !== 0)) {
            countError = true;
          }
          if (count < 0) {
            rangeError = true;
          }
        });
        if (countError) {
          alerts.push(new ObjectAlert(object, "条件式の括弧の数が一致しません。条件式の設定を見直してください。"));
        }
        if (rangeError) {
          alerts.push(new ObjectAlert(object, "条件式の括弧で囲む範囲が一致しません。条件式の設定を見直してください。"));
        }
      }

      // 期間日数の警告確認
      if (object.kind().getValue() === ExpressionKinds.DateDuration) {
        const behavior = object.dateDurationExpressionBehavior().getValue();
        if (!behavior.from) {
          alerts.push(new ObjectAlert(object, "開始日を設定してください。"));
        }
        if (!behavior.to) {
          alerts.push(new ObjectAlert(object, "終了日を設定してください。"));
        }
      }
      
      // 経過時間の警告確認
      if (object.kind().getValue() === ExpressionKinds.TimeSpan) {
        const behavior = object.timeSpanExpressionBehavior().getValue();
        if (!behavior.from) {
          alerts.push(new ObjectAlert(object, "開始日時を設定してください。"));
        }
        if (!behavior.to) {
          alerts.push(new ObjectAlert(object, "終了日時を設定してください。"));
        }
      }

      // 日付比較の警告確認
      if (object.kind().getValue() === ExpressionKinds.DateComparison) {
        const behavior = object.dateComparisonExpressionBehavior().getValue();
        if (behavior.contents.length < 2) {
          alerts.push(new ObjectAlert(object, "条件式項目は2項目以上を設定してください。"));
        }
      }
    }
    return alerts;
  }
}
